import React from "react"
import { Container } from "@material-ui/core"

const Section = ({ children, style, className, ...other }) => {
  return (
    <Container
      maxWidth="md"
      component="section"
      className={className}
      style={{ marginBottom: 24, ...style }}
      {...other}
    >
      {children}
    </Container>
  )
}

export default Section
